// Plain context object. Kept in its own file so config.tsx
// (the Provider) and use-config.ts (the consumer hook) both
// satisfy the react-refresh/only-export-components rule.
import { createContext } from "react";

export interface InrangeAgentsApiConfig {
  baseUrl: string;
}

export const InrangeAgentsApiConfigContext =
  createContext<InrangeAgentsApiConfig | null>(null);
